import { createSlice } from "@reduxjs/toolkit";
const initialStateValue = {
  showRetrievalList: false,
  filterData: {
    branchValue: "",
    branchTouch: false,
    bankName: "",
    bankNameTouch: false,
    dueDate: "",
    dueDateTouch: false,
  },
  gridRows: [],
};
const NachRetrievalReducer = createSlice({
  name: "nachRetrieval",
  initialState: initialStateValue,
  reducers: {
    updateShowRetrievalList(state, action) {
      state.showRetrievalList = action.payload;
    },
    updateBranchTouchHandler(state, action) {
      state.filterData.branchTouch = action.payload;
    },
    updateBankNameTouchHandler(state, action) {
      state.filterData.bankNameTouch = action.payload;
    },
    updateDueDateTouchHandler(state, action) {
      state.filterData.dueDateTouch = action.payload;
    },
    updateGridRows(state, action) {
      state.gridRows = action.payload;
    },
    resetGridRows(state, action) {
      state.gridRows = [];
    },
    resetFilterValues(state, action) {
      state.filterData.branchValue = "";
      state.filterData.bankName = "";
      state.filterData.dueDate = null;
    },
    updateBranchValue(state, action) {
      state.filterData.branchValue = action.payload;
    },
    updateBankNameValue(state, action) {
      state.filterData.bankName = action.payload;
    },
    updateDueDateValue(state, action) {
      state.filterData.dueDate = action.payload;
    },
  },
});
export const NachRetrievalReducerAction = NachRetrievalReducer.actions;
export default NachRetrievalReducer.reducer;
